"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kkdZimmetListeSuzgeciSchema = exports.kkdZimmetListesiSchema = exports.kkdZimmetListeSatiriSchema = exports.kisiKkdZimmetleriSchema = exports.kkdZimmetYetkileriSchema = exports.kkdZimmetSchema = exports.kkdZimmetHamSchema = exports.kkdImzaliNushaSchema = exports.kkdImzaliNushaHamSchema = exports.kkdImzaliNushaAlanlariSchema = exports.kkdZimmetIptalSchema = exports.kkdZimmetOlusturSchema = exports.KKD_KALEM_LISTE_KODU = exports.KKD_IPTAL_GEREKCE_MAX = exports.KKD_ZIMMET_ADET_MAX = exports.KKD_ZIMMET_METNI_MAX = exports.KKD_ZIMMET_STANDART_METNI = void 0;
const zod_1 = require("zod");
const kapi_durumu_1 = require("./kapi-durumu");
/**
 * KKD ZİMMETİ — KURAL VE SÖZLEŞME KATMANI (Kapsam §30; ERD §10j —
 * 07.09.2026; sertleştirme programı sonrası DÖRDÜNCÜ yapım turu).
 *
 * ════════════════════════════════════════════════════════════════════════
 * TURUN TEK CÜMLESİ: KKD ZİMMETİ BİR TESLİM KAYDIDIR — ÖMÜR, STOK VE
 * UYGUNLUK DEĞİL
 * ════════════════════════════════════════════════════════════════════════
 *
 * Kişi + kalem + adet + teslim tarihi + teslim eden (Z1). Sistem *"kimde ne
 * var"* der; *"ne zaman yenilenmeli"* DEMEZ (Z4 — v2'de kalem kuralından
 * türetilir). ⚠️ Bu dosyada vade, ömür, iade ya da stok kavramı YOKTUR ve
 * `kkdZimmetOlusturSchema` STRICT'tir: gövdeye `sonKullanma` gibi bir alan
 * yazan istek 400 alır (Z4 kanaryası — e2e).
 */
/**
 * Z3 — STANDART MATBU METİN. Tenant ayarı `kkd_zimmet_metni`nin
 * VARSAYILANI; müşteri Yapılandırma ekranından değiştirir.
 *
 * ⚠️ Kısa, genel ve İDDİASIZ: *"teslim aldım, kullanmakla yükümlüyüm"*
 * düzeyi. **MEVZUAT ATFI YAPILMAZ** — yönetmelik adı, madde numarası metne
 * girmez (hukuki iddia üretmek ürünün işi değildir; müşteri isterse kendi
 * metnini yazar).
 */
exports.KKD_ZIMMET_STANDART_METNI = 'Aşağıda listelenen kişisel koruyucu donanımları eksiksiz ve kullanılabilir durumda teslim aldım. ' +
    'Bu donanımları işimde amacına uygun olarak kullanmakla, korumakla ve hasar, kayıp ya da ' +
    'kullanılamaz hâle gelmesi durumunda derhal bildirmekle yükümlü olduğumu kabul ederim.';
exports.KKD_ZIMMET_METNI_MAX = 2000;
exports.KKD_ZIMMET_ADET_MAX = 999;
exports.KKD_IPTAL_GEREKCE_MAX = 300;
/** Sözlük liste kodu — §19/16-a envanterinin 36. listesi (✏️ 08.09.2026: kütüphane sınıfı — 22 kalem, madde 210). */
exports.KKD_KALEM_LISTE_KODU = 'kkd_kalemi';
// ── Girdi şemaları ────────────────────────────────────────────────────────
/**
 * Teslim kaydı (Z1). ⚠️ `.strict()` BİLİNÇLİ: Z4 kanaryası — vade/ömür
 * benzeri bir alan ("sonKullanma") gövdeye yazılırsa 400. Tarih GÜN
 * hassasiyetli (G11).
 */
exports.kkdZimmetOlusturSchema = zod_1.z
    .object({
    kalemId: zod_1.z.uuid(),
    adet: zod_1.z.number().int().min(1).max(exports.KKD_ZIMMET_ADET_MAX),
    teslimTarihi: zod_1.z.iso.date(),
})
    .strict();
/** D9 — iptal gerekçe zorunlu (yanlış kaydı geri alma; imzalı satırda 409 serviste). */
exports.kkdZimmetIptalSchema = zod_1.z.object({
    gerekce: zod_1.z.string().trim().min(3).max(exports.KKD_IPTAL_GEREKCE_MAX),
});
/**
 * İmzalı nüsha yükleme (Z6) — multipart'ın düz metin alanı: virgülle
 * ayrılmış teslim kaydı kimlikleri. TEK DOSYA, ÇOK SATIR: bir form birden
 * fazla teslimi kapsar; dosya satır başına kopyalanmaz.
 */
exports.kkdImzaliNushaAlanlariSchema = zod_1.z.object({
    issueIds: zod_1.z
        .string()
        .trim()
        .min(1)
        .transform((s) => s
        .split(',')
        .map((p) => p.trim())
        .filter((p) => p.length > 0))
        .pipe(zod_1.z.array(zod_1.z.uuid()).min(1).max(50)),
});
// ── Yanıt şemaları ────────────────────────────────────────────────────────
exports.kkdImzaliNushaHamSchema = zod_1.z.object({
    /** Bağ satırı kimliği (silme ucu bunu değil, teslim kaydını adresler). */
    id: zod_1.z.uuid(),
    storedFileId: zod_1.z.uuid(),
    dosyaAdi: zod_1.z.string().min(1),
    yukleyenAppUserId: zod_1.z.uuid(),
    yukleyenEtiket: zod_1.z.string().min(1),
    createdAt: zod_1.z.iso.datetime(),
});
/**
 * ✏️ P13-c (madde 227, 12.09.2026) — nüsha SİLME kapısı SATIR BAŞINA:
 * `KKD_NUSHA_SILME_SAPKALARI` (uzman + holding yön.) → kişi bahçesi →
 * sahiplik (yükleyen VEYA holding yön.); kapalı hâl yok. ~~`silebilir`
 * boolean (yalnız yükleyen)~~ söküldü — ekran düğmeyi `silmeKapisi.yazabilir`den
 * çizer, sebebi bölüm başına bir kez yazar.
 */
exports.kkdImzaliNushaSchema = exports.kkdImzaliNushaHamSchema.extend({
    silmeKapisi: kapi_durumu_1.kapiDurumuSchema,
});
/**
 * Teslim kaydı satırı. ⚠️ Vade alanı YOKTUR ve eklenmez (Z4). Kişi yalnız
 * AD ile geçer (kimlik no hiçbir yanıtta yok).
 */
exports.kkdZimmetHamSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    personId: zod_1.z.uuid(),
    kalemId: zod_1.z.uuid(),
    kalemAd: zod_1.z.string().min(1),
    adet: zod_1.z.number().int().positive(),
    teslimTarihi: zod_1.z.iso.date(),
    teslimEdenEtiket: zod_1.z.string().min(1),
    /** İmzalı nüsha — yoksa null (kişi kartında "imzalı nüsha bekliyor"). */
    imzaliNusha: exports.kkdImzaliNushaHamSchema.nullable(),
    createdAt: zod_1.z.iso.datetime(),
});
exports.kkdZimmetSchema = exports.kkdZimmetHamSchema.extend({
    imzaliNusha: exports.kkdImzaliNushaSchema.nullable(),
});
/**
 * ✏️ P13 (yüzey dürüstlüğü artçısı, 12.09.2026 — madde 225): yazma kapısı
 * ARTIK bir `KapiDurumu`dur (şapka `KKD_ZIMMET_YAZMA_SAPKALARI` → kişi bahçesi);
 * eski `yazamamaSebebi` dizgesi ('sapka' | 'bahce') söküldü — ekran cümleyi
 * `KapiSebebi`den kurar, şapka listesi SUNUCUDAN gelir.
 */
exports.kkdZimmetYetkileriSchema = zod_1.z.object({
    /** Şapka ∧ kişi bahçede — kayıt açma · iptal · nüsha yükleme (`yazmaKapisi.yazabilir`). */
    yazabilir: zod_1.z.boolean(),
    yazmaKapisi: kapi_durumu_1.kapiDurumuSchema,
});
/** `GET persons/:personId/ppe-issues` — kişi kartı bölümünün TEK okuyucusu; PDF de bunu okur (P5). */
exports.kisiKkdZimmetleriSchema = zod_1.z.object({
    personId: zod_1.z.uuid(),
    adSoyad: zod_1.z.string().min(1),
    satirlar: zod_1.z.array(exports.kkdZimmetSchema),
    yetkiler: exports.kkdZimmetYetkileriSchema,
});
/** Çalışanlar sekmesi satırı (P4) — kişi bağlantısı için ad + aktif işyeri. */
/** Liste satırı HAM nüsha taşır (silme kapısı yalnız kişi kartında — liste silmez). */
exports.kkdZimmetListeSatiriSchema = exports.kkdZimmetHamSchema.extend({
    personAdSoyad: zod_1.z.string().min(1),
    workplaceAd: zod_1.z.string().nullable(),
});
exports.kkdZimmetListesiSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.kkdZimmetListeSatiriSchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
/** Liste süzgeci — tanınmayan değer sessizce "tümü"ye DÜŞMEZ (400; sunucu `safeParse`). */
exports.kkdZimmetListeSuzgeciSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid().optional(),
    kalemId: zod_1.z.uuid().optional(),
    ara: zod_1.z.string().trim().max(80).optional(),
    sayfa: zod_1.z.coerce.number().int().positive().default(1),
    sayfaBoyutu: zod_1.z.coerce.number().int().positive().max(100).default(25),
});
//# sourceMappingURL=kkd.js.map